import { css, theme, LightTheme, DarkTheme } from '@kui-shared/styles';

const ThemeStyle = css({
  display: 'block',
  backgroundColor: theme.colors.displayBgCanvas,
  color: theme.colors.displayFgLowPrimary,
  fontFamily: theme.fonts.nvidiaSans,
  // TODO: whole app and all components must be 'theme.fontSizes.ms'
  fontSize: theme.fontSizes.md,
  lineHeight: theme.lineHeights.body
});

/**
 * TestIDs
 */
const ThemeTestIDs = {
  Theme: 'kui-theme'
};
/**
 * Defaults
 */
const ThemeDefaults = {
  css: {},
  theme: 'light',
  withCanvas: false,
  withFonts: false,
  withReset: false
};

const KaizenThemeNames = ['light', 'dark'];
const KaizenThemes = new Map([['light', LightTheme.className], ['dark', DarkTheme.className]]);
const getTheme = requestedTheme => {
  var _a;
  // TODO: ideally we only return a real theme or null, but for now the pattern has
  // been established to allow `theme="some-class-of-my-own-theme"` which we should
  // instead support by a independent attribute, but to not trigger a massive diff
  // going to leave this for now
  if (!requestedTheme) {
    return '';
  }
  return (_a = KaizenThemes.get(requestedTheme)) !== null && _a !== void 0 ? _a : requestedTheme;
};

export { KaizenThemeNames, KaizenThemes, ThemeDefaults, ThemeStyle, ThemeTestIDs, getTheme };
